<template>
  <div class="common_content">
    <div class="notice_detail">
      <el-card class="box-card">
        <el-row :gutter="24">
          <el-col :xs="24" :sm="24" :md="24">
            <div class="notice_detail_top">
              <h3>{{noticeContents.news_subject}}</h3>
              <p class="date">创建时间:{{noticeContents.createdate|dateformat('YYYY-MM-DD HH:mm')}}</p>
              <span @click="goBack">返回</span>
            </div>
            <div class="notice_detail_bottom" v-html="noticeContents.news_content"></div>
            <div class="attachment" v-if="noticeContents.attachmentname">
              <h4>附件下载</h4>
              <p @click="download()">{{noticeContents.attachmentname}}</p>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import { GetNewsDetailsList } from "@/api/admin/common.js";
import {  saveFileToLink } from "@/util/download.js";
export default {
  data() {
    return {
      newsId: {},
      noticeContents: {},
      attachmentname: "",
      attachmentpath: "",
      imgPath: window.apiObj.apiUrl,
    };
  },
  created() {
    this.path();
    this.getDetail();
  },
  methods: {
    path() {
      var pathList = [
        { title: "您当前的位置" },
        { title: "首页", path: "/index" },
        { path: "/notice", title: "通知公告" },
        {
          title: "通知公告详情"
        }
      ];
      setTimeout(() => {
        this.$store.commit("SET_ROUTELIST", pathList);
      });
    },
    getDetail() {
      this.newsId.id = this.$route.query.id;
      GetNewsDetailsList(Object.assign(this.newsId)).then(data => {
        var list = data.data.result;
        if (list) {
          this.noticeContents = list.items[0];
          
          this.noticeContents.news_content = this.noticeContents.news_content.replace(new RegExp("/wwwroot", "gm"),this.imgPath);
          
        }
      });
    },
    //返回
    goBack() {
      this.$router.go(-1);
    },
    //下载
    download() {
      const onProgress = (progress) => {
        window.console.log('progress====', progress);
      }
      saveFileToLink(this.imgPath+this.noticeContents.attachmentpath, this.noticeContents.attachmentname,'', onProgress);
    }
  }
};
</script>

<style lang="less" scoped>
.notice_detail {
  .notice_detail_top {
    position: relative;
    padding-top: 15px;
    width: 85%;
    margin: auto;
    h3 {
      text-align: center;
      font-size: 20px;
      font-weight: normal;
      line-height: 26px;
      padding: 0px 20px;
    }
    .date {
      text-align: center;
      font-size: 14px;
      color: #8a8a8a;
      margin: 20px 0 25px 0;
      border-bottom: 1px solid #cdcccc;
      padding-bottom: 15px;
    }
    span {
      cursor: pointer;
      position: absolute;
      color: #f56c6c;
      top: -4%;
      right: 0;
    }
  }
  .notice_detail_bottom {
    width: 85%;
    margin: auto;
    p {
      line-height: 24px;
    }
  }
  .attachment {
    width: 85%;
    margin: auto;
    padding-bottom: 15px;
    h4 {
      margin-bottom: 10px;
    }
    p {
      color: #409eff;
      font-size: 15px;
      cursor: pointer;
    }
    p:hover {
      color: #66b1ff;
    }
  }
}
@media screen and (max-width: 768px) {
  .notice_detail {
    .box-card {
      .notice_detail_top {
        width: 95%;
        h3 {
          font-size: 17px;
        }
        span {
          top: -5px;
          right: -12px;
          font-size: 14px;
        }
      }
      .notice_detail_bottom {
        width: 95%;
      }
    }
  }
}
</style>
<style lang="less">
.notice_detail {
  p {
    line-height: 28px;
  }
  img {
    width: 100%;
  }
}
</style>
